import $ from 'jquery';

$(function () {
  if ($('.section__border').length) {
    // Create Dynamic Container Sizes for Section Border Feature
    const $borders = $('.section__border');
    const calcBorderSize = (size) => {
      switch (size) {
        case 'xs':
          return `${440 + 56}px`;

        case 'sm':
          return `${576 + 56}px`;

        case 'md':
          return `${768 + 56}px`;

        case 'lg':
          return `${970 + 56}px`;

        case 'xl':
          return `${1170 + 56}px`;

        default:
          return;
      }
    };

    $borders.toArray().forEach((border) => {
      const containerSize = $(border).data().containerSize;
      if (containerSize === undefined || containerSize === 'none') return;
      const borderMaxWidth = calcBorderSize(containerSize);
      $(border).css('max-width', borderMaxWidth);
    });

    // Remove Last Card Hr for Mobile Sizes When Page Builder Footer Active
    const handleLastCardHr = () => {
      if ($(window).width() < 970) {
        const containers = $('.container').toArray();
        const containerHasFooter = containers.filter((container) => {
          return $(container).find('.section__footer').length > 0;
        });
        containerHasFooter.forEach((container) => {
          const lastChild = $(container)
            .find('[data-card-size]')
            .children()
            .last();
          lastChild.find('hr').remove();
        });
      }
    };
    handleLastCardHr();
    window.addEventListener('resize', handleLastCardHr);
  }
});
